import type { TemplateDuplicateErrorType } from "./useEmitTemplateDuplicateModalEvent";

/**
 * Maps a tRPC error's HTTP status onto an error_type for the duplicate-failure
 * event (CRTN-10662).
 *
 * Mirrors the editor's getEditFailedErrorType so the guided-templates funnel
 * classifies failures the same way on both sides. `server_error` is kept
 * distinct from `network` because folding a 5xx into `network` would report
 * "the user's connection is bad" when the truth is "our backend is throwing".
 *
 * Note the BFF converts an unreachable templates service into a 500 rather than
 * letting it surface as a missing status (template.source.ts), so a genuine
 * connectivity failure can land as `server_error`. Classifying on status is
 * still the right call — matching on the error message would break the moment
 * that copy changes.
 */
export function getTemplateDuplicateErrorType(
  status: number | undefined,
): TemplateDuplicateErrorType {
  if (status === undefined) return "network";
  if (status === 404) return "not_found";
  if (status === 403) return "permission_denied";
  if (status >= 500) return "server_error";
  return "unknown";
}
